import { isHardware } from '@helpers/isWWAndIsHardware';

import type { IArchivedActionItem } from '../model/archivedAi';

export const getComponentName = (
  item: IArchivedActionItem,
  t: (text: string, fields?: unknown, isMatch?: boolean) => string,
) => {
  return isHardware(item)
    ? t(
        item.equipmentType === 'gateway'
          ? 'WW SystemCommHub'
          : item.equipmentType === 'node'
          ? 'WW SystemNode'
          : 'WW SystemRepeater',
      )
    : item.pointName || '';
};
